<template lang="html">
  <f7-page>
    <div class="navbar">
      <div class="navbar-inner">
        <div class="left">
          <a href="#"
            @click="$f7router.back()">
            <f7-icon f7="chevron_left" />
          </a>
        </div>
        <div
          class="title"
          v-if="poi.title">
          {{ poi.title }}
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div class="poi-page">
      <div
        class="poi-image"
        v-if="poi.image">
        <img
          :src="poi.image" />
      </div>
      <PoiContent
        v-if="content.length"
        :content="content" />
    </div>
  </f7-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { getPoiContent } from '@/components/modules/AtlasPois/service'
import PoiContent from '@/components/modules/AtlasPois/PoiContent'
export default {
  name: 'PoiPage',
  components: {
    PoiContent
  },
  data () {
    return {
      poi: {},
      content: []
    }
  },
  computed: {
    ...mapGetters({
      doc: 'db/doc'
    })
  },
  methods: {
    getPoi (poiid) {
      this.doc('poi', poiid).then(poi => {
        this.poi = poi
      })
    },
    getContent (poiid) {
      this.$f7.preloader.show()
      const id = poiid.split('-')
      const lang = id[0]
      const page = Number(id[1])
      getPoiContent(page, lang).then(doc => {
        doc.content().then(paragraphs => {
          this.$f7.preloader.hide()
          this.content = paragraphs.filter(p => p.content)
        })
      })
    }
  },
  mounted () {
    this.getPoi(this.$f7route.params.poiid)
    this.getContent(this.$f7route.params.poiid)
  }
}
</script>

<style lang="scss">
.poi-page {
  .poi-image {
    line-height: 0;
    background: #cdbb9f;
    img {
      width: 100%;
      height: auto;
    }
  }
  .accordion-list {
    margin-top: 0;
  }
}
</style>
